import React from 'react'
import styled from 'styled-components'
import ApplicationDropdown from './Components/ApplicationDropdown/ApplicationDropdown'
import RecentChats from './Components/RecentChats/RecentChats'
import { modes } from 'app.config';
import { useSelector } from 'react-redux';
import CreateImage from './Components/CreateImage/CreateImage';
import SmallScreenMenu from '../../Content/SmallScreenMenu';

const NewSidebar = ({ isMobile }) => {
  const mode = useSelector(state => state.utils.mode);
  
  return (
    <Container>
      {
        isMobile &&
        <SmallScreenMenu
          showMainText={true}
        />
      }
       
      {
        mode === modes.image ? (<> <CreateImage /> </>) : (<>
          <div><ApplicationDropdown /></div>
          <div><RecentChats /></div>
        </>)
      }
    </Container>
  )
}

export default NewSidebar

const Container = styled.div`
    display: flex;
    flex-direction: column;
    overflow: auto;
    width: calc(100% - 64px);
    height:  calc(100vh - 50px);
    background-color: #2E2F33;
    color: white;
    position: relative;
    overflow: hidden;

    @media only screen and (max-width: 1000px) {
        /* display: none; */
        height: 100vh;
        width: 100%;
            /* height: calc(-41px + 100vh); */

        & .left-sidebar-col{
          display: none !important;
        }
    }
`

